export function parsePackageTagline(tagline) {
  if (typeof tagline !== "string") return [];

  return tagline
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
}
